import styled, { css } from "styled-components";
import { cloud, ninja } from "@vitalsource/vstui/colors";
import createThemedComponent from "@vitalsource/vstui/themes/createThemedComponent";
import { Button } from "@vitalsource/vstui";
import { List } from "@vitalsource/vstui/labs";
import { AccordionButton, Caret } from "../../../../components/accordion";
import { Account, Tools, Apps, Help } from "../icons";

export const Wrapper = styled.div`
  display: flex;
  height: 100vh;
`;

export const StyledBackground = styled.div`
  background-color: ${ninja.getShade(11)};
  height: 100%;
  overflow: auto;
  width: ${props => props.width}px;
`;

export const Header = styled.h2`
  color: #ffffff;
  padding: 15px 58px 13px 18px;
  border-bottom: 1px ${ninja.getShade(10)} solid;
`;

export const FullName = styled.div`
  font-size: 20px;
  width: 184px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Email = styled.div`
  font-weight: normal;
  width: 184px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const InstallNative = styled.div`
  border-bottom: 1px ${ninja.getShade(10)} solid;
  color: white;
  padding: 13px 29px 17px 31px;
`;

export const ExploreFeatures = styled.p`
  font-size: 16px;
  margin-top: 0;
  margin-bottom: 25px;
  text-align: center;
`;

const buttonStyles = css`
  align-items: center;
  background-color: ${ninja.getShade(11)};
  border: none;
  border-bottom: 1px solid ${ninja.getShade(10)};
  color: white;
  display: flex;
  font-size: 15px;
  padding: 17px 20px;
  width: 100%;

  &:active,
  &[aria-expanded="true"] {
    background-color: rgb(255, 255, 255, 0.08);
  }
`;

export const StyledAccordionButton = styled(AccordionButton)`
  font-weight: 400;
  ${buttonStyles};
`;

export const StyledCaret = styled(Caret)`
  margin-left: auto;
`;

StyledCaret.defaultProps = { color: cloud.getShade(5) };

export const ThemedList = createThemedComponent(List, props => ({
  List_backgroundColor: ninja.getShade(10),
  ListDivider_color: ninja.getShade(10),
  ListItem_color: props.theme.vstui.color.white,
  ListItem_backgroundColor_hover: ninja.getShade(10),
  ListItem_fontSize: 15,
  ListItem_boxShadow_focus: `inset 0 1px 0px 0px white, inset 0 -1px 0px 0px white`
}));

const iconStyles = css`
  margin-right: ${props => (props.smallMargin ? 4 : 13)}px;
`;

export const AccountIcon = styled(Account)`
  ${iconStyles};
`;

export const ToolsIcon = styled(Tools)`
  ${iconStyles};
`;

export const AppsIcon = styled(Apps)`
  ${iconStyles};
`;

export const HelpIcon = styled(Help)`
  ${iconStyles};
`;

const StyledButton = styled(Button)`
  ${buttonStyles};
  svg {
    margin-right: 4px;
  }
`;

export const ThemedStyledButton = createThemedComponent(StyledButton, {
  ButtonContent_justifyContent: "left",
  Button_minHeight_medium: 54
});
